import { TextInput } from '@jfs/ui-new'
import { tableItemStrings } from '../../data/static/strings'

const validateInput = (changedValue: string, maxValue: number): string => {
  if (+changedValue > maxValue) {
    return tableItemStrings.invalidAmount
  }
  return ''
}

const getRefundProcessView = (entry: any, onChangeInput: (value: string) => void, data: any) => {
  const amount = data?.amount?.split(' ')[1] ?? data?.amount
  const refundAmount = data?.refundAmount?.split(' ')[1] ?? data?.refundAmount
  return (
    <TextInput
      testID="refundInput"
      value={entry.value}
      onChangeText={onChangeInput}
      error={validateInput(entry.value, +amount - +refundAmount)}
      touched
      type={'h4'}
    />
  )
}

export { getRefundProcessView }
